import { useEffect, useState } from 'react';

import { motion } from 'framer-motion';
import { useAppContext } from 'contexts/AppContext';
import { sendPasswordResetEmail } from 'api/index';
import { validate, tryGetUserStatus } from 'utils/index';
import AuthLayout from '@/components/layouts/AuthLayout/AuthLayout';
import Head from 'next/head';
import Button from '@/components/elements/Button/Button';
import Input from '@/components/elements/Input/Input';
import HintMessage from '@/components/elements/HintMessage/HintMessage';

import styles from '../styles/AuthScreens.module.scss';

const ForgotPassword = ({ userStatus }) => {

    const { appLoading, setAppLoading, setUserStatus } = useAppContext()
    userStatus && setUserStatus(userStatus)

    const [email, setEmail] = useState("")
    const [hint, setHint] = useState({type: "", message: ""})
    const [success, setSuccess] = useState(false)

    useEffect(()=>{
        if(email !== ""){
            const validation = validate.email(email)
            validation.valid ? setHint({type:"error", message: ""}) : setHint({type:"error", message: validation.message})
        }
    }, [email])

    async function handleEmailLink(){
        setAppLoading(true)
        try{
            const res = await sendPasswordResetEmail({email});
            if(res.data.status === "success"){
                setSuccess(true)
                setHint({type:"success", message: "Password reset link sent!"})
            }else{
                setHint({type:"error", message: "An error occured."})
            }
        }catch(e){
            setHint({type:"error", message: "An error occured."})
        }
        setAppLoading(false)
    }

    return (
        <>
            <Head>
                <title>Forgot passowrd | afterglow</title>
            </Head>

            <AuthLayout title="Forgot password?">
                <div className={styles.forgotPassword}>
                    <form onSubmit={(e)=>{e.preventDefault(), handleEmailLink()}}>
                        <div className={styles.inputsSection}>
                            <motion.div className={styles.inputs} initial={{y: 20, opacity: 0}} animate={{y:0, opacity: 1}} transition={{ delay: .3, duration: .35 }}>
                                <Input type="email" autoFocus={true} value={email} placeholder="Type your email" onChange={(email) => setEmail(email)} disabled={appLoading} />
                            </motion.div>

                            <HintMessage type={hint.type} show={hint.message!==""}>
                                {hint.message}
                            </HintMessage>

                            <motion.div className={styles.buttonContainer} initial={{y: 20, opacity: 0}} animate={{y:0, opacity: 1}} transition={{ delay: .5, duration: .35 }}>
                                <Button type="submit" active={!appLoading && validate.email(email).valid && !success}>Email Password Reset Link</Button>
                            </motion.div>
                        </div>
                    </form>
                </div>
            </AuthLayout>
        </>
     );
}

export async function getServerSideProps(context) {
    const res = await tryGetUserStatus(context)
    return {props:{
        userStatus: res.data ? res.data : false
    }}
}

export default ForgotPassword;
